import { PaneArea } from '../../../types/shared'
import Triangle, { ITriangleAttrs } from '../../canvas/triangle'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = ITriangleAttrs
type PartialAttrs = Partial<Attrs>

class TriangleCreator extends Triangle<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    const width = this.model.scale.x.width(35)
    const height = this.model.scale.y.height(35)
    this.attrs.x1 = startArea.x - width
    this.attrs.x2 = startArea.x + width
    this.attrs.x3 = startArea.x
    this.attrs.y1 = startArea.y + height / 2
    this.attrs.y2 = startArea.y + height / 2
    this.attrs.y3 = startArea.y - height / 2

    setTimeout(() => {
      this.replaceMyself(Triangle.fromObject<Triangle>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default TriangleCreator
